"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParams = exports.default = void 0;
var _qs = _interopRequireDefault(require("qs"));
const useQueryParams = function () {
  const {
    search = ""
  } = window.location;
  return _qs.default.parse(search.substr(1));
};
exports.useQueryParams = useQueryParams;
var _default = exports.default = useQueryParams;